export default function ({ props }: any) {
    return (
        <span className={`ef-icon`} {...props}>
            <svg width="1em" height="1em" viewBox="0 0 14 8">
                <path
                    d="M7 5.38L2.237.66A.872.872 0 0 0 1.6.4c-.25 0-.463.087-.638.26S.7 1.044.7 1.292s.087.458.263.632L6.4 7.312c.4.396.813.384 1.238-.037l5.4-5.351c.175-.174.262-.384.262-.632s-.087-.458-.263-.632C12.864.487 12.65.4 12.4.4s-.462.087-.637.26L7 5.38z"
                    fill="currentColor"
                    fillRule="evenodd"
                />
            </svg>
        </span>
    );
}
